"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _makeStyles = _interopRequireDefault(require("@material-ui/core/styles/makeStyles"));

var _clsx = _interopRequireDefault(require("clsx"));

var _SearchResultSelectorProduct = _interopRequireDefault(require("./SearchResultSelectorProduct"));

var _SearchResultSelectorArticle = _interopRequireDefault(require("./SearchResultSelectorArticle"));

var _SearchResultSelectorDocument = _interopRequireDefault(require("./SearchResultSelectorDocument"));

var _SearchResultSelectorTaxonomy = _interopRequireDefault(require("./SearchResultSelectorTaxonomy"));

/* eslint-disable no-nested-ternary */
var useStyles = (0, _makeStyles.default)(function () {
  return {
    root: {},
    component: {}
  };
}, {
  name: 'SxSearchResultSelector'
});

var cond = function cond() {
  for (var _len = arguments.length, cnds = new Array(_len), _key = 0; _key < _len; _key++) {
    cnds[_key] = arguments[_key];
  }

  return function (v) {
    return (cnds.find(function (x) {
      return x[0](v);
    }) || [null, function () {
      return undefined;
    }])[1](v);
  };
};

var selectComponentForItem = cond([function (type) {
  return type === 'product';
}, function () {
  return _SearchResultSelectorProduct.default;
}], [function (type) {
  return type === 'article';
}, function () {
  return _SearchResultSelectorArticle.default;
}], [function (type) {
  return type === 'taxonomy';
}, function () {
  return _SearchResultSelectorTaxonomy.default;
}], [function (type) {
  return type === 'document';
}, function () {
  return _SearchResultSelectorDocument.default;
}]);

function SearchResultSelector(_ref) {
  var pClasses = _ref.classes,
      className = _ref.className,
      onClose = _ref.onClose,
      result = _ref.result,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["classes", "className", "onClose", "result"]);
  var classes = useStyles({
    classes: pClasses,
    className: className
  });
  var entityType = result.entityType;
  if (!entityType) return null;
  var Component = selectComponentForItem(entityType);
  return Component ? /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, rest, {
    className: (0, _clsx.default)(classes.root, className)
  }), /*#__PURE__*/_react.default.createElement(Component, {
    item: result.entity,
    className: (0, _clsx.default)(classes.component, className),
    onClose: onClose
  })) : null;
}

process.env.NODE_ENV !== "production" ? SearchResultSelector.propTypes = {
  classes: _propTypes.default.shape({
    component: _propTypes.default.string,
    root: _propTypes.default.string
  }),
  className: _propTypes.default.string,
  onClose: _propTypes.default.func,
  result: _propTypes.default.shape({
    entity: _propTypes.default.shape({}),
    entityType: _propTypes.default.string
  }).isRequired
} : void 0;
SearchResultSelector.defaultProps = {
  classes: undefined,
  className: undefined,
  onClose: undefined
};
var _default = SearchResultSelector;
exports.default = _default;